import { isSupabaseError, SupabaseCodeError } from "../../../constants/supabaseErrors";

/**
 * Maps Supabase / PostgreSQL error codes to clear, user-facing French messages.
 */
export function formatProviderTagError(error: unknown, defaultMessage = 'Erreur lors de la gestion du tag.'): string {
  if (isSupabaseError(error)) {
    switch (error.code) {
      case SupabaseCodeError.UniquenessViolation:
      case '23505':
        return 'Un tag portant ce nom existe déjà.';
      case '42501':
        return "Vous n'avez pas les autorisations nécessaires pour gérer les tags.";
      case '23514':
        return 'Le nom du tag est invalide.';
      case '23503':
        return 'La copropriété associée est introuvable.';
      default:
        return error.message || defaultMessage;
    }
  }

  if (error instanceof Error) {
    if (
      error.message.includes('23505') ||
      error.message.includes('unique constraint') ||
      error.message.includes('provider_tags_space_id_name_key')
    ) {
      return 'Un tag portant ce nom existe déjà.';
    }
    if (error.message.includes('42501') || error.message.includes('policy')) {
      return "Vous n'avez pas les autorisations nécessaires pour gérer les tags.";
    }
    return error.message;
  }

  return defaultMessage;
}

